import { Post } from "./apiService";
import { BASE_URL, POST_AMENDMENT_REPORT, SYSTEM_ERROR } from "./CONSTANTS";

export const uploadAmendmentFile = (request) => {
    const { queryParams } = request;

    return new Promise((resolve, reject) => {
        try {
            request.url = `${BASE_URL}users/userId/${POST_AMENDMENT_REPORT}?customerId=&amendCancelReasons=${queryParams.amendCancelReasons}&fileName=${queryParams.fileName}&apikey=${request.apiKey}`;

            request.config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }

            Post(request)
                .then((res) => {
                    if (res) {
                        resolve(res);
                    }
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};